import { App } from "antd";

export const useNotification = () => {
  const { notification } = App.useApp();
  return {
    showSuccessNotification: (message: string, key?: string) => {
      notification.success({
        placement: "bottomRight",
        message: message,
        showProgress: true,
        pauseOnHover: true,
        key,
      });
    },
    showErrorNotification: (message: string, desciption?: string, key?: string) => {
      notification.error({
        placement: "bottomRight",
        message: message,
        description: desciption,
        showProgress: true,
        pauseOnHover: true,
        key,
      });
    },
  };
};
